export const GET: string = 'get'
export const POST: string = 'post'
